import { RoleType } from 'types/store';
import { CronHour } from 'types/types';

export const startMobileSize = 1024;

export const roleItems: Array<{ name: string; value: RoleType }> = [
  { name: 'Админ', value: 'admin' },
  { name: 'Аналитик', value: 'analyst' },
  { name: 'Разработчик', value: 'developer' },
  { name: 'Зритель/Бизнес-пользователь', value: 'viewer' },
];

export const roleData: Record<RoleType, string> = {
  admin: 'Админ',
  analyst: 'Аналитик',
  developer: 'Разработчик',
  viewer: 'Зритель/Бизнес-пользователь',
};

export const defaultCronDate: CronHour = {
  type: 'hour',
  minutes: 0,
  hours: 0,
};
